@if (message()) {
  <div class="extra message">
    <div class="message-text" [innerHTML]="message() | safeHtml"></div>
    <div class="dismiss-icon" (click)="dismissMessage()">
      <span class="material-icons">close</span>
    </div>
  </div>
}
@if (showUpdate()) {
  <div class="reload message">
    <div class="message-text">Eine neue Version von Meine NV ist verfügbar!
      <div (click)="reload()" class="reload-button">
        <span>JETZT LADEN</span>
        <span class="material-icons">refresh</span>
      </div>
    </div>
  </div>
}

